var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBoImageDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.00586,
    r: 7,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.151 9.12315C3.94958 9.32506 3.94968 9.6522 4.15123 9.85399C4.35296 10.056 4.68006 10.0559 4.88166 9.85376L6.99871 7.73148L9.11847 9.85388C9.32015 10.0558 9.64726 10.0559 9.849 9.85399C10.0507 9.65222 10.0507 9.32509 9.84912 9.12326L7.72844 6.99995L9.83508 4.88811C10.0365 4.68619 10.0364 4.35906 9.83485 4.15727C9.63312 3.9553 9.30602 3.9554 9.10442 4.1575L6.99826 6.26886L4.89267 4.16065C4.69099 3.95872 4.36388 3.95867 4.16213 4.16054C3.96048 4.36231 3.96043 4.68944 4.16202 4.89128L6.26852 7.00039L4.151 9.12315Z",
    fill: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoImageDelete);
export default __webpack_public_path__ + "static/media/icon__bo__image-delete.5c5ca0a55904c98e804bdbd7df503056.svg";
export { ForwardRef as ReactComponent };